export default __webpack_public_path__ + "static/media/sa.f3d773c7.svg";